import React, { useState } from "react";
import Input from "../components/inputs/Input";
import Button from "../components/buttons/Button";
import Layout from "../layouts/Auth";

export default ({ history, location }) => {
  const [login, setLogin] = useState("");
  const [message, setMessage] = useState();

  const send = async () => {
    const formData = new FormData();
    formData.append("user_login", login);
    formData.append("redirect_to", "");
    const options = {
      method: "post",
      body: formData
    };
    try {
      const resultRaw = await fetch(
        "/wp-login.php?action=lostpassword",
        options
      );
      const htmlResult = await resultRaw.text();
      if (!htmlResult.includes("ERROR")) {
        setMessage("Please check your mail for reset password link");
      } else setMessage("There is no account with that email address.");
    } catch (error) {
      console.error(error);
      setMessage(
        "There is an error on server side. Please contact an administrator."
      );
    }
  };

  return (
    <Layout withLogin>
      <div
        name="lostpasswordform"
        id="lostpasswordform"
        className="pForgottenPassword"
      >
        <h3>Forgotten password</h3>
        <label htmlFor="user_login">
          <Input
            type="text"
            name="user_login"
            id="user_login"
            value={login}
            setValue={setLogin}
            placeholder="Your email address"
            label="Please enter your email address. You will receive a link to create a
            new password via email."
          />
        </label>
        <Button onClick={send}>Get new password</Button>
        {message && <div className="pForgottenPassword_message">{message}</div>}
      </div>
    </Layout>
  );
};
